import persistStore from "redux-persist/es/persistStore";
import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { setupListeners } from "@reduxjs/toolkit/query";
import app from "./app/app.slice";
import { countryApi } from "./app/country.api";
import { authApi } from "./auth/auth.api";
import auth from "./auth/auth.slice";
import geniusSchool from "./genius/geniusSchool.slice";
import { otpApi } from "./auth/otp.api";
import { apiMutaion } from "./ApiMutaion";
import { geniusMarketingApi } from "./genius/geniusMarketing.api";
import { omsMutation } from "./OmsMutation";
import { deviceLocationMiddleware } from "./auth/deviceLocation.middleware";
import { updateExamIdMiddleware } from "./auth/updateExamId.middleware";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"]
};

const apiReducers = [authApi, apiMutaion, geniusMarketingApi, omsMutation, otpApi, countryApi];

const reducers = combineReducers({
  ...apiReducers.reduce((acc, item) => ({ ...acc, [item.reducerPath]: item.reducer }), {}),
  auth,
  app,
  geniusSchool
});

const persistedReducer = persistReducer(persistConfig, reducers);

const middleware = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    serializableCheck: false
  })
    
    .concat(apiReducers.map((item) => item.middleware))
    .concat(deviceLocationMiddleware)
    .concat(updateExamIdMiddleware);

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== "production",
  middleware
});

export const persistor = persistStore(store);

setupListeners(store.dispatch);
